import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createOrder = async (orderData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/api/orders`, orderData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        
        return response.data;
    } catch (error) {
        console.error("Error creating order:", error);
        throw error;
    }
};